import { Provider } from 'react-redux';
import { ProgressBarStyle } from './modules/core_web/minimals.cc/components/LoadingScreen';
import NotistackProvider from './modules/core_web/minimals.cc/components/NotistackProvider';
import RtlLayout from './modules/core_web/minimals.cc/components/RtlLayout';
import ScrollToTop from './modules/core_web/minimals.cc/components/ScrollToTop';
import SessionTimeoutManager from './modules/core_web/keycloak/SessionTimeoutManager';
import Settings from './modules/core_web/minimals.cc/components/settings';
import ThemePrimaryColor from './modules/core_web/minimals.cc/components/ThemePrimaryColor';
import ThemeConfig from './modules/core_web/minimals.cc/theme';
import GlobalStyles from './modules/core_web/minimals.cc/theme/globalStyles';
import Router from './modules/logistica_web/routes';
import { store } from './modules/logistica_web/store';
import { LicenseInfo } from '@mui/x-data-grid-premium';

LicenseInfo.setLicenseKey(process.env.REACT_APP_MATERIAL_UI_LICENCE_KEY_PREMIUM!);

function App(): JSX.Element {
  return (
    <ThemeConfig>
      <ThemePrimaryColor>
        <Provider store={store}>
          <RtlLayout>
            <NotistackProvider>
              <GlobalStyles />
              <ProgressBarStyle />
              <SessionTimeoutManager />
              <Settings />
              <ScrollToTop />
              <Router />
            </NotistackProvider>
          </RtlLayout>
        </Provider>
      </ThemePrimaryColor>
    </ThemeConfig>
  );
}

export default App;
